import styled from 'styled-components';

export const ContainerTable = styled.div`
  .table {
    margin-top: 10px;
    min-height: 320px;
  }
  .table .hideRightSeparator .MuiDataGrid-columnSeparator {
    display: none;
  }
`;
